import { Pie } from 'react-chartjs-2';

const JumlahPengguna = ({chartData}) => {
  return (
    <div className='chart-container'>
        <Pie
        data={chartData}
        options={{ 
            plugins: {
                title: {
                    display: true,
                }
            }
         }}/>
    </div>
  )
}

export default JumlahPengguna